
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import api from '../../Services/api';

import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Grid, MenuItem, Select, FormControl, InputLabel
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';


const ClientList = () => {
    let data = sessionStorage.getItem('user');
    let corporateData = JSON.parse(data);
    let id = corporateData.id;


     const [clients, setClients] = useState([]);
      const [loading, setLoading] = useState(true);
       const [snackbarOpen, setSnackbarOpen] = useState(false);
      const [snackbarMessage, setSnackbarMessage] = useState('');
      const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
      const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
      

      useEffect(() => {
        const timer = setTimeout(() => {
          api.Corporate.getClientByCorporateId(id)
            .then(response => {
              if (response.status === 200) {
                setClients(response.data.data);
              } else if (response.status === 404) {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                setClients([]);
              } else if (response.status === 505) {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
              } else {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage('Some error occurred, Please try again');
              }
            })
            .catch(error => {
              console.error(`Error fetching Corporate Names`, error);
              setErrorSnackbarOpen(true);
              setSnackbarErrorMessage('Network or server error');
            })
            .finally(() => {
              setLoading(false);
            });
        }, 600);
      
        return () => clearTimeout(timer);
      }, []);
      



  return (
    <div>
          <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  
                  }}
                  severity="success"
                  open={snackbarOpen}
                  autoHideDuration={2000}
                  onClose={() => setSnackbarOpen(false)}
                  sx={{
                    marginTop: '2.9%', 
                    marginRight: '7%'
                  }}
                >
                  <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                </Snackbar>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  severity="error"
                  open={errorSnackbarOpen}
                  autoHideDuration={2000}
                  sx={{
                    marginTop: '2.9%', 
                    marginRight: '7%'
                  }}
                  onClose={() => {setErrorSnackbarOpen(false)}}
                >
                  <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                </Snackbar>
        {loading ? (
             <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
             <h3>Loading</h3>
    <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
    <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
    <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
    
    </div>
              ) : 
          clients && clients.length > 0 ? (
          <div className="m-4">
            <h5>Establishment List <i class="bi bi-arrow-right-square-fill" ></i></h5>
           
              <TableContainer>
                <div style={{ minHeight:"420px",maxHeight: "440px", marginTop:"10px", overflowY: "auto" }}>
                <Table style={{  width: '100%',borderTop:'none' }}>
                  <TableHead className="position-sticky top-0 " style={{zIndex:1000, backgroundColor: 'black', color: 'white', fontWeight: 'bold',borderTop:"none" }}>
                    <TableRow style={{backgroundColor:'black',color:'white'}}>
                      <th className='border-top-0'>Principal Employer Details</th>
                      <th className='border-top-0'>Contractor Details</th>
                   
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {clients.map((client) => (
                      <TableRow key={client.companyId}>
                        <TableCell>
                        <div style={{fontSize:"14px",fontWeight:'bold'}}>{client.principleEmployer}</div>
                      
                          <div style={{color:'gray'}} >Address : {client.companyAddress}, {client.placeName} {client.stateId}- {client.pinCode}</div>
                          
                          <div style={{color:'gray'}} >Contact Person : {client.authorisedPersonName}</div>
                          <div style={{color:'gray'}} >Contact Number : {client.companyPhoneNumber} {client.companyPhoneNumber1 && `, ${client.companyPhoneNumber1}`}</div>
                          <div style={{color:'gray'}} >Email : {client.companyEmailId} {client.companyEmailId1 && `, ${client.companyEmailId1}`}</div>
                        </TableCell>
                        <TableCell>
                          <div style={{fontSize:"14px",fontWeight:'bold'}}>{client.clientName}</div>
                          <div style={{color:'gray'}}>Address: {client.clientAddress}</div>

                          <div style={{color:'gray'}} >Contact Person : {client.clientContactPersonName}</div>
                          <div style={{color:'gray'}} >Contact Number : {client.clientContactPersonPhoneNumber} {client.clientContactPersonPhoneNumber1 && `, ${client.clientContactPersonPhoneNumber1}`}</div>
                          <div style={{color:'gray'}} >Email : {client.clientContactPersonEmailId} {client.clientContactPersonEmailId1 && `, ${client.clientContactPersonEmailId1}`}</div>
                          <div style={{color:'gray'}} >Contract Start Date : {client.startDate?.slice(0,10).split('-').reverse().join('-')}</div>
                          <div style={{color:'gray'}} >Contract End Date : {client.endDate?.slice(0,10).split('-').reverse().join('-')}</div>
                        </TableCell>
                     
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                </div>
              </TableContainer>
              </div>
          ) : (
            <div>
              <p className="text-center text-danger p-5">No Client Found !!</p>
            </div>
          )}
    </div>
  )
}

export default ClientList
